// VERSION 1.0.0
// AUTHOR: AGALYA

import TransferCenterActionTypes from './transfer-center.types';

/*************** CREATE TRANSFER LOG START  ******************/
export const createTransferLogStart = (getData: any) => ({
	type: TransferCenterActionTypes.CREATE_TRANSFER_LOG_START,
	payload: getData,
});

export const createTransferLogSuccess = (successData: any) => ({
	type: TransferCenterActionTypes.CREATE_TRANSFER_LOG_SUCCESS,
	payload: successData,
});

export const createTransferLogFailure = (failureData: unknown) => ({
	type: TransferCenterActionTypes.CREATE_TRANSFER_LOG_FAILURE,
	payload: failureData,
});

export const createTransferLogResponseResetStart = () => ({
	type: TransferCenterActionTypes.CREATE_TRANSFER_LOG_RESPONSE_RESET_START,
});

export const createTransferLogResponseChanged = () => ({
	type: TransferCenterActionTypes.CREATE_TRANSFER_LOG_RESPONSE_CHANGED,
});
/*************** CREATE TRANSFER LOG END ******************/

/*************** MEMBER CENTER TRANSFER START  ******************/
export const createCenterTransferStart = (getData: any) => ({
	type: TransferCenterActionTypes.CREATE_CENTER_TRANSFER_START,
	payload: getData,
});

export const createCenterTransferSuccess = (successData: any) => ({
	type: TransferCenterActionTypes.CREATE_CENTER_TRANSFER_SUCCESS,
	payload: successData,
});

export const createCenterTransferFailure = (failureData: unknown) => ({
	type: TransferCenterActionTypes.CREATE_CENTER_TRANSFER_FAILURE,
	payload: failureData,
});

export const createCenterTransferResponseResetStart = () => ({
	type: TransferCenterActionTypes.CREATE_CENTER_TRANSFER_RESPONSE_RESET_START,
});

export const createCenterTransferResponseChanged = () => ({
	type: TransferCenterActionTypes.CREATE_CENTER_TRANSFER_RESPONSE_CHANGED,
});
/*************** MEMBER CENTER TRANSFER END ******************/

/*************** FETCH TRANSFER CENTER DETAILS START  ******************/
export const fetchTransferCenterDetailsStart = (getData: any) => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_START,
	payload: getData,
});

export const fetchTransferCenterDetailsSuccess = (successData: any) => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchTransferCenterDetailsFailure = (failureData: unknown) => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchTransferCenterDetailsResponseResetStart = () => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_RESPONSE_RESET_START,
});

export const fetchTransferCenterDetailsResponseChanged = () => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_CENTER_DETAILS_RESPONSE_CHANGED,
});
/*************** FETCH TRANSFER CENTER DETAILS END ******************/

/*************** FETCH TRANSFER GROUP DETAILS START  ******************/
export const fetchTransferGroupDetailsStart = (getData: any) => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_START,
	payload: getData,
});

export const fetchTransferGroupDetailsSuccess = (successData: any) => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchTransferGroupDetailsFailure = (failureData: unknown) => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchTransferGroupDetailsResponseResetStart = () => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_RESPONSE_RESET_START,
});

export const fetchTransferGroupDetailsResponseChanged = () => ({
	type: TransferCenterActionTypes.FETCH_TRANSFER_GROUP_DETAILS_RESPONSE_CHANGED,
});
/*************** FETCH TRANSFER GROUP DETAILS END ******************/
